/**
 * @fileoverview GET handler for the "/generative_ai/brand_guideline_document" endpoint.
 * Returns the document's raw bytes (not JSON), so this uses fetchBlob instead of the
 * standard reactQueryFetcherAdapter.
 */
import { fetchBlob } from "@lib/fetch";

import type { GetGenerativeAiBrandGuidelineDocumentBlobProps } from "./types";

/**
 * Streams a document's bytes from the private bucket. Errors reject the returned promise for the
 * caller to map (see {@link getBrandGuidelineDocumentErrorCode}) — the global error modal is
 * suppressed so a failed download doesn't double-surface.
 */
export const getGenerativeAiBrandGuidelineDocumentBlob = ({
  guidelineId,
  documentId,
}: GetGenerativeAiBrandGuidelineDocumentBlobProps): Promise<Blob> =>
  fetchBlob(
    "/generative_ai/brand_guideline_document",
    "GET",
    {
      guideline_id: guidelineId,
      document_id: documentId,
    },
    {},
    // Passing settings replaces fetchBlob's default wholesale, so restate all three keys.
    { setContentType: false, fetchBlobType: true, propagateFetchRequestError: false }
  );
